module.exports = __webpack_public_path__ + "img/conduct.3fa2b528.png";